import React from "react";

export class AppPage {
    public href: string;
    public label: string;
    public external: boolean;
    public iconName?: IconName;
    public hasRightButton?: boolean;
    public hasHoverTooltip?: boolean;
    public tooltipContent?: React.ReactNode;
    public children?: Array<AppPage>;

    constructor({
        href,
        label,
        external,
        iconName,
        hasRightButton = false,
        hasHoverTooltip = false,
        tooltipContent,
        children = []
    }: {
        href: string;
        label: string;
        external: boolean;
        iconName?: IconName;
        hasRightButton?: boolean;
        hasHoverTooltip?: boolean;
        tooltipContent?: React.ReactNode;
        children?: Array<AppPage>;
    }) {
        this.href = href;
        this.label = label;
        this.external = external;
        this.iconName = iconName;
        this.hasRightButton = hasRightButton;
        this.hasHoverTooltip = hasHoverTooltip;
        this.tooltipContent = tooltipContent;
        this.children = children;
    }

    active(pathname: string): boolean {
        // Special case: /bookmark should be active when on /history as they share the same tab
        if (this.href === "/bookmark" && pathname === "/history") {
            return true;
        }
        return this.href === pathname;
    }
}
